import React from "react";
import ReactDOM from "react-dom";

import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, Lorem, ModalFooter, SimpleGrid, FormControl, FormLabel, Input, FormErrorMessage, useColorModeValue, Text } from '@chakra-ui/react';
import { Formik, Form, Field } from 'formik';
import Select from 'react-select'
import Yup from 'yup'


function LoadingModal(props) {
    const { isOpen, onClose, data, type } = props

    return (
        <>
            {isOpen && (
                <div className="loading-screen">
                    <div className="loading-icon"></div>
                </div>
            )}
        </>
    )
}

export default LoadingModal;